export const testIds = {
    createSurveyButton: 'survey-create__preset-description-create-survey-button'
} as const;
